const initialState = () => ({
  unassignedPotentialBidders: [],
  status: {
    error: null,
    pending: true,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  getUnassignedPotentialBidders({ commit }, { quotes, potentialBidders }) {
    commit('GET_UNASSIGNED_POTENTIAL_BIDDERS', { quotes, potentialBidders });
  },
};

const mutations = {
  GET_UNASSIGNED_POTENTIAL_BIDDERS(state, { quotes, potentialBidders }) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };

    if (potentialBidders.length < 0) {
      state.unassignedPotentialBidders = [];
      state.status = {
        pending: false,
      };
      return;
    }

    state.unassignedPotentialBidders = potentialBidders.filter(
      (bidder) => !quotes.some((quote) => quote.sourceId === bidder.id),
    );

    state.status = {
      pending: false,
    };
  },
};

const getters = {
  unassignedPotentialBidders: (state) => state.unassignedPotentialBidders,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const unassignedPotentialBidders = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
